// @flow

export * as actions from './actions';

// current node process
export const IS_DEVEL = process.env.NODE_ENV !== 'production';

export const INFO_POP_UP = 'INFO_POP_UP';
export const VOTE_POP_UP = 'VOTE_POP_UP';

export const STARS_TITLES = {
	ONE: 'אל תטרחו',
	TWO: 'מומלץ לוותר',
	THREE: `רק אם אין מה לראות`,
	FOUR: `מעולה! לזה חיכיתם`,
	FIVE: `צפיית חובה`,
};

// routes
export const ROOT_ROUTE = '/:id';
export const PREVIEW_ROUTE = '/preview/:id';
